module.exports = __webpack_public_path__ + "../resources/img/ic_re_400error_glass_img.2bf1ad9d.svg";